// bootstrap italia version variable
// useful to check for the current version

const BOOTSTRAP_ITALIA_VERSION = '2.12.1'
export default BOOTSTRAP_ITALIA_VERSION
